'use strict';

import AlbumStore from 'stores/AlbumStore';
import AlbumActions from 'actions/AlbumActions';
import React from 'react';
import {browserHistory} from 'react-router';
import API from 'sources/API';
import {BounceLoader} from 'react-spinners';
import Navigator from './NavigatorComponent';
import AlbumBriefComponent from './AlbumBriefComponent';
import MediaArticleListComponent from './MediaArticleListComponent';

require('styles/AlbumArticle.scss');
require('styles/SweetLoading.scss');

let that;
class AlbumArticleComponent extends React.Component {
  constructor(props) {
    super(props);
    let albumStore = AlbumStore.getState();
    this.state = {
      album_id: this.props.params.id,
      album: albumStore.album,
      albumMedia: albumStore.albumArticleMedia,
      isCollect: albumStore.album.isCollect,
      totalPrice: albumStore.totalPrice,
      paySignature: albumStore.paySignature,
      product: null,
      isAuthor: false,
      loading: true,
      hasMore: true,
      showNavigator: false,
      isShare: false,
      recommendArticles: []
    }
    this.onAlbumChange = this.onAlbumChange.bind(this);
    this.onCollect = this.onCollect.bind(this);
    this.onUncollect = this.onUncollect.bind(this);
    this.onAlbumEdit = this.onAlbumEdit.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.onArticleScroll = this.onArticleScroll.bind(this);
  }
  componentWillMount(){
    let { query } = this.props.location;
    if(query.type === 'share'){
      this.setState({isShare:true});
    }
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }

    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.onArticleScroll);

    AlbumStore.listen(this.onAlbumChange);
    AlbumActions.cleanAlbumMedia();
    AlbumActions.fetchAlbumDetail(this.props.params.id);
    AlbumActions.fetchAlbumArticleMedia(this.props.params.id);

    that = this;
    fetch(API.getRecommendAlbumList.replace(':id',this.props.params.id)).then(res=>res.json()).then(json => {
      if(json.status == 0){
        that.setState({
          recommendArticles: json.result
        })
      }
    })
    
    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    AlbumActions.updateArticleOffset($(document).scrollTop());
    AlbumStore.unlisten(this.onAlbumChange);
    window.removeEventListener('scroll', this.onArticleScroll);
  }
  onAlbumChange(state) {
    this.setState({
      album: state.album,
      product: state.album.product,
      albumMedia: state.albumArticleMedia,
      totalPrice: state.totalPrice,
      paySignature: state.paySignature,
      isCollect: state.album.isCollect,
      isAuthor: state.album.isAuthor,
      loading: (state.album._id&&state.album._id===this.props.params.id&&!state.loading)?false:true,
      hasMore: state.moreAlbumMedias
    });
    let albumName = this.state.album.name;
    let cover = this.state.albumMedia[0]?this.state.albumMedia[0].images.small[0]:"";
      window.wx.onMenuShareTimeline({
        title: `${albumName}-小地球旅行`, // 分享标题
        link: `${location.href}?type=share`, // 分享链接
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png') // 分享图标
      });
      window.wx.onMenuShareAppMessage({
        title: `${albumName}-小地球旅行`, // 分享标题
        desc: `${albumName}。加入小地球旅行，发现有趣的地方`, // 分享描述
        link: `${location.href}?type=share`, // 分享链接
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png'), // 分享图标
        type: 'link' // 分享类型,music、video或link，不填默认为link
      });

    // SEO 优化
    let title = albumName;
    window.changeMetaForSEO(title);
  }
  onCollect() {
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'album',
      eventAction: 'collect',
      eventLabel: 'albumId',
      eventValue: this.state.album_id
    });
    AlbumActions.postCollectAlbum(this.state.album_id, 'collect');
  }
  onUncollect() {
    // AlbumActions.postCollectAlbum(this.state.album_id, 'uncollect');
  }
  onAlbumEdit() {
    browserHistory.push(`/album/${this.state.album_id}/edit`);
  }
  onGoBack() {
    browserHistory.goBack()
  }
  onArticleScroll() {
    let scrollTop = $(document).scrollTop();
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  render() {
    let navigator1, navigator2, navigator3;
    if(this.state.showNavigator){
      navigator1 = <Navigator action='top' number={3} />;
    }
    if(this.state.isAuthor){
      navigator2 = <Navigator action='edit' callback={this.onAlbumEdit} />
    } else {
      if(this.state.isCollect){
        navigator2 = <Navigator action='saved' callback={this.onUncollect}/>
      } else {
        navigator2 = <Navigator action='save' callback={this.onCollect}/>
      }
    }
    if(this.state.isShare){
      navigator3 = <Navigator action='home' number={2} />
    }else{
      navigator3 = <Navigator action='left' number={2} />
    }
    return (
      <div className="album-article-component">
        <div className='sweet-loading'>
          <BounceLoader
            sizeUnit={"px"}
            size={50}
            color={'#333'}
            loading={this.state.loading}
          />
        </div>
        <AlbumBriefComponent
          album={this.state.album}
          count={this.state.album.media_amount}
          paySignature={this.state.paySignature}
          totalPrice={this.state.totalPrice}
          isAuthor={this.state.isAuthor}
        />
        <MediaArticleListComponent
          mediaList={this.state.albumMedia}
          product={this.state.product}
          view_article={this.state.album.view_article}
          recommendArticles={this.state.recommendArticles}
        />
        {navigator1}
        {navigator2}
        {navigator3}
      </div>
    );
  }
}

AlbumArticleComponent.displayName = 'AlbumArticleComponent';

export default AlbumArticleComponent;



// WEBPACK FOOTER //
// ./src/components/AlbumArticleComponent.js